/**
 * Comparación de instantes que llegan de la API.
 *
 * Los timestamps viajan como string ISO 8601 (`res.json` serializa los `Date`), y comparar esos
 * strings «a pelo» funciona mientras el backend use siempre el mismo formato
 * (`2026-09-25T12:00:00.000Z`) y deja de funcionar en cuanto cambia la precisión o aparece un
 * desfase horario (`+02:00`). Por eso se comparan marcas de tiempo y solo se cae al texto si el ISO
 * viene roto (que no debería pasar, pero un `Invalid Date` silencioso sí).
 *
 * Lo usan los avisos del inbox (`features/alerts`) para decidir si un mensaje es posterior al
 * instante en que esa conversación se dio por vista.
 */

/** ¿`a` es posterior a `b`? (ambos ISO 8601). */
export function esPosterior(a: string, b: string): boolean {
  const ta = Date.parse(a);
  const tb = Date.parse(b);

  if (Number.isNaN(ta) || Number.isNaN(tb)) return a > b;
  return ta > tb;
}
